import ActiveSubscription from "types/ActiveSubscription";
import { DataRouteDefinition } from "routes/data-routes/types";


export const ActiveSubscriptionDataRoutePath = "/data-routes/billing-data/subscription";

type BaseActiveSubscriptionDataRouteType = Required<DataRouteDefinition<
  ActiveSubscription,
  "activeSubscription",
  typeof ActiveSubscriptionDataRoutePath
>>;

export type ActiveSubscriptionDataRouteType = Omit<BaseActiveSubscriptionDataRouteType, "useActiveSubscription"> & {
  useActiveSubscription: () => ReturnType<BaseActiveSubscriptionDataRouteType["useActiveSubscription"]> & {
    subscriptionSyncPending: boolean;
    subscriptionSyncTimedOut: boolean;
    retrySubscriptionSync: () => void;
  };
};
